import React from 'react';
import ReactDOM from 'react-dom';
import { Game } from './views/Game';

import 'primereact/resources/themes/md-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './index.css';

ReactDOM.render(<Game />, document.getElementById('root'));
